import React from "react";
import AppraisalSummary from "./AppraisalSummary";
import { Divider } from "antd";
import { filter, map } from "lodash";
import appConfig from "../../../../config/config.json";
import { useStaffAppraisalsStore } from "../../../../config/stores";
import moment from "moment";

const PrintAppraisal = () => {
  const staffAppraisalsStore = useStaffAppraisalsStore();
  const { staffAppraisalDetails } = staffAppraisalsStore;
  return (
    <>
      <h5 className="text-center fw-bold">AMANI INITIATIVE</h5>
      <p className="text-center fw-bold mb-0">
        STAFF PERFORMANCE APPRAISAL FORM
      </p>
      <p className="fw-bold"> Introduction:</p>
      <span>
        In-order to stay on track with our work, we need to know how we are or
        have performed. In all work situations, there should be individual and
        team desire to be better than what we are. This requires us to evaluate
        and be evaluated. This performance evaluation form is to help us measure
        your performance against standards set in the job descriptions and
        targets. It’s purely a confidential tool and should be taken with very
        honest and open-mindedness.
      </span>
      <AppraisalSummary />
      <p className="mb-0 fw-bold">
        <mark>PART 1: - EMPLOYEE (APPRAISEE) SECTION</mark>
      </p>
      <Divider orientation="left" className="text-uppercase fw-bold">
        Section 1: Employee's Self-Appraisal
      </Divider>
      <p className="ms-2">
        1. What were your key achievements during the appraisal period ?
      </p>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ width: 20 }}>S/N</th>
            <th>Achievements</th>
          </tr>
        </thead>
        <tbody>
          {map(staffAppraisalDetails?.achievements, (achievement, idx) => (
            <tr>
              <td>{idx + 1}</td>
              <td>{achievement.achievement}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="ms-2">
        2. What challenges did you face, and how did you address them?
      </p>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ width: 20 }}>S/N</th>
            <th>Challenge</th>
            <th>How you addressed the challenge</th>
          </tr>
        </thead>
        <tbody>
          {map(staffAppraisalDetails?.challenges, (challenge, idx) => (
            <tr>
              <td>{idx + 1}</td>
              <td>{challenge.challenge}</td>
              <td>{challenge.challenge_solution}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="ms-2">
        3. What are your personal development goals and support needed for the
        next appraisal period?
      </p>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ width: 20 }}>S/N</th>
            <th>Personal Development Goal</th>
            <th>Support Needed</th>
          </tr>
        </thead>
        <tbody>
          {map(staffAppraisalDetails?.development_goals, (challenge, idx) => (
            <tr>
              <td>{idx + 1}</td>
              <td>{challenge.development_goal}</td>
              <td>{challenge.support_needed}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Divider orientation="left" className="text-uppercase fw-bold">
        Section 2: Appraisal of Annual Targets self-assessment.
      </Divider>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ width: 20 }}>S/N</th>
            <th>Roles and Responsibilities</th>
            <th>Key Performance Indicators (KPIs)</th>
            <th>Annual Target</th>
            <th>Achievement (Quantitative)</th>
            <th>Achievement (Qualitative)</th>
          </tr>
        </thead>
        <tbody>
          {map(staffAppraisalDetails?.self_assessment, (assessment, idx) => (
            <tr>
              <td>{idx + 1}</td>
              <td>
                {
                  assessment?.performance_indicator?.assessmentArea
                    ?.assessment_area
                }
              </td>
              <td>
                {assessment?.performance_indicator?.key_performance_indicator}
              </td>
              <td>{assessment?.performance_indicator?.annual_target}</td>
              <td>{assessment?.quantitative_assessment?.toLocaleString()}</td>
              <td>{assessment.qualitative_assessment}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mb-0 fw-bold">
        <mark>PART 2: - EMPLOYER (APPRAISER) SECTION</mark>
      </p>
      <Divider orientation="left" className="text-uppercase fw-bold">
        Section 3: Appraisal of Annual Targets Supervisor assessment
      </Divider>
      <table className="table table-sm table-bordered">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Roles and Responsibilities</th>
            <th>Key Performance Indicators (KPIs)</th>
            <th>Target</th>
            <th>Achieved (based on employee information)</th>
            <th>Rating (1-5)</th>
            <th>Supervisor Comments for each rating</th>
          </tr>
        </thead>
        <tbody>
          {map(staffAppraisalDetails?.self_assessment, (assessment, idx) => (
            <tr>
              <td>{idx + 1}</td>
              <td>
                {
                  assessment?.performance_indicator?.assessmentArea
                    ?.assessment_area
                }
              </td>
              <td>
                {assessment?.performance_indicator?.key_performance_indicator}
              </td>
              <td>{assessment?.performance_indicator?.annual_target}</td>
              <td>{assessment?.quantitative_assessment?.toLocaleString()}</td>
              <td>{assessment.rating_scale}</td>
              <td>{assessment.supervisor_comment}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Divider orientation="left" className="text-uppercase fw-bold">
        Section 4: Soft Skills Enhancement
      </Divider>
      <table className="table table-sm table-bordered">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Soft Skill</th>
            <th>Examples of Application</th>
            <th>Rating (1-5)</th>
            <th>Supervisor Comments for each rating</th>
          </tr>
        </thead>
        <tbody>
          {map(
            staffAppraisalDetails?.softSkillEnhancements,
            (softSkill, idx) => (
              <tr>
                <td>{idx + 1}</td>
                <td>{softSkill.soft_skill_enhancement}</td>
                <td>{softSkill.example_of_application}</td>
                <td>{softSkill.rating}</td>
                <td>{softSkill.comment}</td>
              </tr>
            )
          )}
        </tbody>
      </table>
      <Divider orientation="left" className="text-uppercase fw-bold">
        Section 5: Capacity Development Goals
      </Divider>
      <table className="table table-sm table-bordered">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Development Target</th>
            <th>Status on Development target</th>
            <th>Rating (1-5)</th>
            <th>Comments by Appraiser</th>
          </tr>
        </thead>
        <tbody>
          {map(
            filter(staffAppraisalDetails.capacityDevelopmentGoals, {
              is_first_appraisal: false,
            }),
            (softSkill, idx) => (
              <tr key={softSkill.development_target}>
                <td>{idx + 1}</td>
                <td>{softSkill.development_target}</td>
                <td>{softSkill.status}</td>
                <td>{softSkill.rating_scale}</td>
                <td>{softSkill.supervisor_comment}</td>
              </tr>
            )
          )}
        </tbody>
      </table>
      <Divider orientation="left" className="text-uppercase fw-bold">
        Section 6: Overall Performance Summary
      </Divider>
      <table className="table table-sm table-bordered">
        <tbody>
          <tr>
            <td className="fw-bold w-50">Achievement of Targets</td>
            <td>{staffAppraisalDetails.achievement_of_target_rating}</td>
          </tr>
          <tr>
            <td className="fw-bold">Soft Skills Enhancement</td>
            <td>{staffAppraisalDetails.soft_skills_enhancement}</td>
          </tr>
          <tr>
            <td className="fw-bold">Capacity Development Goals</td>
            <td>{staffAppraisalDetails.capacity_development_goals_rating}</td>
          </tr>
          <tr>
            <td className="fw-bold">Overall Performance</td>
            <td>{staffAppraisalDetails.overall_performance_rating}</td>
          </tr>
        </tbody>
      </table>
      <p className="fw-bold mb-0">Rating Scale:</p>
      <p>
        1 – Unsatisfactory, 2 – Needs Improvement, 3 – Meets Expectations, 4 –
        Exceeds Expectations, 5 – Outstanding
      </p>
      <p className="mb-0 fw-bold">
        <mark>PART 3: JOINT PLANNING (EMPLOYEE AND DIRECT EMPLOYEE)</mark>
      </p>
      <Divider orientation="left" className="text-uppercase fw-bold">
        Section 7: Capacity Development Targets
      </Divider>
      <table className="table table-sm table-bordered">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Development Target</th>
            <th>Planned Activities/Training</th>
            <th>Impact on Performance </th>
            <th>Resources Needed</th>
          </tr>
        </thead>
        <tbody>
          {map(
            filter(staffAppraisalDetails.capacityDevelopmentGoals, {
              is_first_appraisal: true,
            }),
            (softSkill, idx) => (
              <tr key={softSkill.development_target}>
                <td>{idx + 1}</td>
                <td>{softSkill.development_target}</td>
                <td>{softSkill.planned_activities}</td>
                <td>{softSkill.impact_on_performance}</td>
                <td>{softSkill.resources_needed}</td>
              </tr>
            )
          )}
        </tbody>
      </table>
      <Divider orientation="left" className="text-uppercase fw-bold">
        Section 8: Performance targets for next appraisal period
      </Divider>
      <table className="table table-sm table-bordered">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Goal/Target</th>
            <th>Key Performance Indicators (KPIs)</th>
            <th>Timeline </th>
            <th>Resources Needed</th>
          </tr>
        </thead>
        <tbody>
          {map(
            staffAppraisalDetails.appraisalGoalsForNextPeriod,
            (softSkill, idx) => (
              <tr key={softSkill.development_target}>
                <td>{idx + 1}</td>
                <td>{softSkill.goal}</td>
                <td>
                  {
                    softSkill?.key_performance_indicator
                      ?.key_performance_indicator
                  }
                </td>
                <td>{softSkill.timeline}</td>
                <td>{softSkill.resources_needed}</td>
              </tr>
            )
          )}
        </tbody>
      </table>
      <p className=" fw-bold">
        <mark>SIGN OFF</mark>
      </p>
      <p className="mb-0">
        Employee: {staffAppraisalDetails?.user?.first_name}{" "}
        {staffAppraisalDetails?.user?.other_names}
      </p>
      <p className="mb-0">
        Employee Comment: {staffAppraisalDetails.employee_comment}
      </p>
      <p>
        <div className="d-flex">
          <div className="w-50">
            {staffAppraisalDetails?.user?.signature && (
              <img
                src={`${appConfig.server_url}${staffAppraisalDetails?.user?.signature}`}
                alt="signature"
                width="30"
                height="15"
              />
            )}
          </div>
          <div className="w-50">
            Date:{" "}
            {moment(staffAppraisalDetails.employee_comment_date).format(
              "dddd Do MMMM YYYY"
            )}
          </div>
        </div>
      </p>
      <p className="mb-0">
        Appraiser: {staffAppraisalDetails?.supervisor?.first_name}{" "}
        {staffAppraisalDetails?.supervisor?.other_names}
      </p>
      <p className="mb-0">
        Appraiser Comment: {staffAppraisalDetails.appraiser_comment}
      </p>
      <p>
        <div className="d-flex">
          <div className="w-50">
            {staffAppraisalDetails?.supervisor?.signature && (
              <img
                src={`${appConfig.server_url}${staffAppraisalDetails?.supervisor?.signature}`}
                alt="signature"
                width="30"
                height="15"
              />
            )}
          </div>
          <div className="w-50">
            Date:{" "}
            {moment(staffAppraisalDetails.appraiser_comment_date).format(
              "dddd Do MMMM YYYY"
            )}
          </div>
        </div>
      </p>
      <p className="mb-0">
        Department Head Comment (if applicable):{" "}
        {staffAppraisalDetails?.headOfDepartment?.first_name}
        {staffAppraisalDetails?.headOfDepartment?.other_names}
      </p>
      <p className="mb-0">
        Department Head Comment (if applicable):{" "}
        {staffAppraisalDetails.head_of_department_comment}
      </p>
      <p>
        <div className="d-flex">
          <div className="w-50">
            {staffAppraisalDetails?.headOfDepartment?.signature && (
              <img
                src={`${appConfig.server_url}${staffAppraisalDetails?.headOfDepartment?.signature}`}
                alt="signature"
                width="30"
                height="15"
              />
            )}
          </div>
          <div className="w-50">
            Date:{" "}
            {moment(staffAppraisalDetails.head_of_department_date).format(
              "dddd Do MMMM YYYY"
            )}
          </div>
        </div>
      </p>
      <p className="mb-0">
        Executive Director:
        {staffAppraisalDetails?.executiveDirector?.first_name}
        {staffAppraisalDetails?.executiveDirector?.other_names}
      </p>
      <p className="mb-0">
        Executive Director Comment:
        {staffAppraisalDetails.executive_director_comment}
      </p>
      <p>
        <div className="d-flex">
          <div className="w-50">
            {staffAppraisalDetails?.executiveDirector?.signature && (
              <img
                src={`${appConfig.server_url}${staffAppraisalDetails?.executiveDirector?.signature}`}
                alt="signature"
                width="30"
                height="15"
              />
            )}
          </div>
          <div className="w-50">
            Date:{" "}
            {moment(staffAppraisalDetails.head_of_department_date).format(
              "dddd Do MMMM YYYY"
            )}
          </div>
        </div>
      </p>
    </>
  );
};

export default PrintAppraisal;
